import { useEffect } from 'react';

import { getLocalStorage } from '@shared/constants';

export const UserGuidingIdentify = () => {
    useEffect(() => {
        const email = getLocalStorage('userEmail');
        if (!email) return;

        if (window.userGuiding) {
            window.userGuiding.identify(email, { email });
            return;
        }

        let attempts = 0;
        const interval = setInterval(() => {
            if (window.userGuiding || ++attempts >= 10) {
                clearInterval(interval);
                window.userGuiding?.identify(email, { email });
            }
        }, 500);

        return () => clearInterval(interval);
    }, []);

    return null;
};
